export const nav = [
  { text: "home", path: "/" },
  {
    text: "about",
    path: "/about",
  },
  {
    text: "services",
    path: "/services",
  },
  {
    text: "listings",
    path: "/listings",
  },
  {
    text: "pricing",
    path: "/pricing",
  },
  {
    text: "contact",
    path: "/contact",
  },
]
export const featured = [
  {
    cover: "../images/hero/h1.png",
    name: "Family House",
    total: "122 Property",
  },
  {
    cover: "../images/hero/h2.png",
    name: "House & Villa",
    total: "155 Property",
  },
  {
    cover: "../images/hero/h3.png",
    name: "Apartment",
    total: "300 Property",
  },
  {
    cover: "../images/hero/h4.png",
    name: "Office & Studio",
    total: "80 Property",
  },
  {
    cover: "../images/hero/h6.png",
    name: "Villa & Condo",
    total: "80 Property",
  },
]
export const list = [
  {
    id: 1,
    cover: "../images/list/p-1.png",
    gallery: ["../images/list/p-1.png", "../images/list/p-2.png", "../images/list/p-4.png", "../images/list/p-6.png"],
    name: "Vista Hill — Lakeside Apartment",
    location: "210 Zirak Road, Canada",
    category: "For Rent",
    price: "$3,700",
    type: "Apartment",
    beds: 3,
    baths: 2,
    area: "1,250 sq ft",
    description: "Bright lakeside apartment with modern finishes and stunning water views. Open-plan living and dining, updated kitchen with premium appliances, and a private balcony. Building amenities include a gym, pool, and 24/7 concierge. Available for long-term lease.",
  },
  {
    id: 2,
    cover: "../images/list/p-2.png",
    gallery: ["../images/list/p-2.png", "../images/list/p-1.png", "../images/list/p-4.png"],
    name: "Vista Hill — Park View Condo",
    location: "5698 Zirak Road, New York",
    category: "For Sale",
    price: "$9,750",
    type: "Condos",
    beds: 4,
    baths: 3,
    area: "2,100 sq ft",
    description: "Spacious park-view condo in a sought-after building. Master suite with walk-in closet and en suite, two additional bedrooms, and a den. High ceilings, large windows, and a terrace overlooking the park. One parking space included.",
  },
  {
    id: 3,
    cover: "../images/list/p-7.png",
    gallery: ["../images/list/p-7.png", "../images/list/p-5.png", "../images/list/p-2.png"],
    name: "Vista Hill — Central Office Space",
    location: "5624 Mooker Market, USA",
    category: "For Rent",
    price: "$5,860",
    type: "Offices",
    beds: null,
    baths: 2,
    area: "3,400 sq ft",
    description: "Prime central office space with excellent transport links. Open floor plan suitable for teams of 20–40, meeting rooms, and reception area. Modern HVAC, raised flooring, and fiber connectivity. Flexible lease terms available.",
  },
  {
    id: 4,
    cover: "../images/list/p-4.png",
    gallery: ["../images/list/p-4.png", "../images/list/p-1.png", "../images/list/p-6.png", "../images/list/p-2.png"],
    name: "Vista Hill — Liverpool Family Home",
    location: "5621 Liverpool, London",
    category: "For Sale",
    price: "$7,540",
    type: "Homes & Villas",
    beds: 5,
    baths: 4,
    area: "2,800 sq ft",
    description: "Detached family home on a quiet street with a private garden and off-street parking. Five bedrooms including a ground-floor guest suite, two reception rooms, and a large kitchen-diner. Close to top schools and transport.",
  },
  {
    id: 5,
    cover: "../images/list/p-5.png",
    gallery: ["../images/list/p-5.png", "../images/list/p-7.png", "../images/list/p-4.png"],
    name: "Vista Hill — Montreal Commercial",
    location: "210 Montreal Road, Canada",
    category: "For Rent",
    price: "$4,850",
    type: "Commercial",
    beds: null,
    baths: 2,
    area: "2,200 sq ft",
    description: "Versatile commercial unit ideal for retail, showroom, or light office use. High visibility frontage, loading access, and ample storage. Located on a busy commercial strip with strong footfall.",
  },
  {
    id: 6,
    cover: "../images/list/p-6.png",
    gallery: ["../images/list/p-6.png", "../images/list/p-1.png", "../images/list/p-4.png"],
    name: "Vista Hill — Garden Apartment",
    location: "210 Zirak Road, Canada",
    category: "For Sale",
    price: "$2,742",
    type: "Apartment",
    beds: 2,
    baths: 1,
    area: "850 sq ft",
    description: "Charming garden-level apartment with direct access to a shared courtyard. Two bedrooms, updated bathroom, and an open kitchen-living area. Ideal first-time purchase or investment. Low maintenance fees.",
  },
]
export const awards = [
  {
    icon: <i className='fa-solid fa-trophy'></i>,
    num: "12K+",
    name: "Properties Listed",
  },
  {
    icon: <i className='fa-solid fa-briefcase'></i>,
    num: "500+",
    name: "Custom Builds Completed",
  },
  {
    icon: <i className='fa-solid fa-lightbulb'></i>,
    num: "15+",
    name: "Years in Real Estate",
  },
  {
    icon: <i className='fa-solid fa-heart'></i>,
    num: "8K+",
    name: "Happy Clients",
  },
]
/** Wikimedia Commons city photos (CC BY-SA). ?width=800 serves a resized image. */
const wikiImg = (fileName) =>
  `https://commons.wikimedia.org/wiki/Special:FilePath/${encodeURIComponent(fileName)}?width=800`

export const location = [
  {
    id: 1,
    name: "Accra, Greater Accra",
    Villas: "12 Villas",
    Apartments: "10 Apartments",
    Offices: "07 Offices",
    cover: wikiImg("Accra Skyline 3.jpg"),
  },
  {
    id: 2,
    name: "Kumasi, Ashanti Region",
    Villas: "12 Villas",
    Apartments: "10 Apartments",
    Offices: "07 Offices",
    cover: wikiImg("Downtown Kumasi, Ghana.jpg"),
  },
  {
    id: 3,
    name: "Tamale, Northern Region",
    Villas: "12 Villas",
    Apartments: "10 Apartments",
    Offices: "07 Offices",
    cover: wikiImg("Tamale City View, Northern Ghana.jpg"),
  },
  {
    id: 4,
    name: "Takoradi, Western Region",
    Villas: "12 Villas",
    Apartments: "10 Apartments",
    Offices: "07 Offices",
    cover: wikiImg("Takoradi Oilfield and Harbour.jpg"),
  },
  {
    id: 5,
    name: "Cape Coast, Central Region",
    Villas: "12 Villas",
    Apartments: "10 Apartments",
    Offices: "07 Offices",
    cover: wikiImg("Cape Coast Castle, Cape Coast, Ghana.JPG"),
  },
  {
    id: 6,
    name: "Tema, Greater Accra",
    Villas: "12 Villas",
    Apartments: "10 Apartments",
    Offices: "07 Offices",
    cover: wikiImg("Tema (city)1.JPG"),
  },
]
export const team = [
  {
    list: "50",
    cover: "../images/customer/team-1.jpg",
    address: "Liverpool, Canada",
    name: "Sargam S. Singh",
    icon: [<i className='fa-brands fa-facebook-f'></i>, <i className='fa-brands fa-linkedin'></i>, <i className='fa-brands fa-twitter'></i>, <i className='fa-brands fa-instagram'></i>],
  },
  {
    list: "70",
    cover: "../images/customer/team-2.jpg",
    address: "Montreal, Canada",
    name: "Harijeet M. Siller",
    icon: [<i className='fa-brands fa-facebook-f'></i>, <i className='fa-brands fa-linkedin'></i>, <i className='fa-brands fa-twitter'></i>, <i className='fa-brands fa-instagram'></i>],
  },
  {
    list: "80",
    cover: "../images/customer/team-3.jpg",
    address: "Denver, USA",
    name: "Anna K. Young",
    icon: [<i className='fa-brands fa-facebook-f'></i>, <i className='fa-brands fa-linkedin'></i>, <i className='fa-brands fa-twitter'></i>, <i className='fa-brands fa-instagram'></i>],
  },
  {
    list: "51",
    cover: "../images/customer/team-4.jpg",
    address: "2272 Briarwood Drive",
    name: "Michael P. Grimaldo",
    icon: [<i className='fa-brands fa-facebook-f'></i>, <i className='fa-brands fa-linkedin'></i>, <i className='fa-brands fa-twitter'></i>, <i className='fa-brands fa-instagram'></i>],
  },
  {
    list: "42",
    cover: "../images/customer/team-5.jpg",
    address: "2272 Briarwood Drive",
    name: "Sarah L. Chen",
    icon: [<i className='fa-brands fa-facebook-f'></i>, <i className='fa-brands fa-linkedin'></i>, <i className='fa-brands fa-twitter'></i>, <i className='fa-brands fa-instagram'></i>],
  },
  {
    list: "38",
    cover: "../images/customer/team-5.jpg",
    address: "Montreal, USA",
    name: "Adam K. Jollio",
    icon: [<i className='fa-brands fa-facebook-f'></i>, <i className='fa-brands fa-linkedin'></i>, <i className='fa-brands fa-twitter'></i>, <i className='fa-brands fa-instagram'></i>],
  },
]
export const price = [
  {
    plan: "Property Search",
    price: "Free",
    ptext: "browse & get in touch",
    list: [
      { icon: <i className='fa-solid fa-check'></i>, text: "Browse all listings" },
      { icon: <i className='fa-solid fa-check'></i>, text: "Save favourites to My List" },
      { icon: <i className='fa-solid fa-check'></i>, text: "Contact agents directly" },
      { change: "color", icon: <i className='fa-solid fa-x'></i>, text: "Build consultation" },
      { change: "color", icon: <i className='fa-solid fa-x'></i>, text: "Custom design & build" },
    ],
  },
  {
    best: "Popular",
    plan: "Build Consultation",
    price: "Quote",
    ptext: "request a build quote",
    list: [
      { icon: <i className='fa-solid fa-check'></i>, text: "Everything in Property Search" },
      { icon: <i className='fa-solid fa-check'></i>, text: "Site visit & feasibility" },
      { icon: <i className='fa-solid fa-check'></i>, text: "Design ideas & rough quote" },
      { icon: <i className='fa-solid fa-check'></i>, text: "Dedicated build specialist" },
      { change: "color", icon: <i className='fa-solid fa-x'></i>, text: "Full project management" },
    ],
  },
  {
    plan: "Design & Build",
    price: "Quote",
    ptext: "full service from design to keys",
    list: [
      { icon: <i className='fa-solid fa-check'></i>, text: "Everything in Build Consultation" },
      { icon: <i className='fa-solid fa-check'></i>, text: "Architectural & interior design" },
      { icon: <i className='fa-solid fa-check'></i>, text: "Permits & construction" },
      { icon: <i className='fa-solid fa-check'></i>, text: "Project manager from start to finish" },
      { icon: <i className='fa-solid fa-check'></i>, text: "Handover & aftercare" },
    ],
  },
]
export const footer = [
  {
    title: "Our Services",
    text: [
      { list: "Buy & Rent" },
      { list: "Custom Build" },
      { list: "Design & Build" },
      { list: "Property Types" },
      { list: "Request a Quote" },
    ],
  },
  {
    title: "Contact Us",
    text: [
      { list: "Email: hello@vistahillhouses.com" },
      { list: "Phone: +1 (234) 567-890" },
      { list: "Request a build quote anytime" },
    ],
  },
  {
    title: "Company",
    text: [{ list: "About" }, { list: "Listings" }, { list: "Pricing" }],
  },
]
